import {
    DRIP_CAMPAIGN_CHANGE,
    DRIP_CAMPAIGN_WIZARD_INITIALIZE,
    DRIP_CAMPAIGN_WIZARD_FETCH_MESSAGES,
    DRIP_CAMPAIGN_WIZARD_SET_MESSAGES,
    DRIP_CAMPAIGN_WIZARD_FETCH_GROUPS,
    DRIP_CAMPAIGN_WIZARD_SET_GROUPS,
    DRIP_CAMPAIGN_WIZARD_FETCH_SENDERS,
    DRIP_CAMPAIGN_WIZARD_SET_SENDERS,
    DRIP_CAMPAIGN_WIZARD_SAVE,
    DRIP_CAMPAIGN_WIZARD_SAVE_SUCCESS,
    DRIP_CAMPAIGN_WIZARD_SAVE_ERROR,
    DRIP_ENROLLMENT_FETCH,
    DRIP_ENROLLMENT_FETCHED
} from './actionTypes';

// Basic drip campaign change action
export const dripCampaignChange = (field, value) => ({
    type: DRIP_CAMPAIGN_CHANGE,
    meta: {
        field,
    },
    payload: value,
});

// Wizard actions
export const dripCampaignWizardInitialize = () => ({
    type: DRIP_CAMPAIGN_WIZARD_INITIALIZE
});

export const dripCampaignWizardFetchMessages = () => ({
    type: DRIP_CAMPAIGN_WIZARD_FETCH_MESSAGES
});

export const dripCampaignWizardSetMessages = (messages) => ({
    type: DRIP_CAMPAIGN_WIZARD_SET_MESSAGES,
    payload: messages
});

export const dripCampaignWizardFetchGroups = () => ({
    type: DRIP_CAMPAIGN_WIZARD_FETCH_GROUPS
});

export const dripCampaignWizardSetGroups = (groups) => ({
    type: DRIP_CAMPAIGN_WIZARD_SET_GROUPS,
    payload: groups
});

export const dripCampaignWizardFetchSenders = () => ({
    type: DRIP_CAMPAIGN_WIZARD_FETCH_SENDERS
});

export const dripCampaignWizardSetSenders = (senders) => ({
    type: DRIP_CAMPAIGN_WIZARD_SET_SENDERS,
    payload: senders
});

export const dripCampaignWizardSave = (redirectTo = null) => ({
    type: DRIP_CAMPAIGN_WIZARD_SAVE,
    meta: {
        redirectTo
    }
});

export const dripCampaignWizardSaveSuccess = (record) => ({
    type: DRIP_CAMPAIGN_WIZARD_SAVE_SUCCESS,
    payload: record
});

export const dripCampaignWizardSaveError = (error) => ({
    type: DRIP_CAMPAIGN_WIZARD_SAVE_ERROR,
    payload: error,
    error: true
});

// Enrollment actions
export const dripEnrollmentFetch = (campaignId) => ({
    type: DRIP_ENROLLMENT_FETCH,
    payload: campaignId
});

export const dripEnrollmentFetched = (enrollments) => ({
    type: DRIP_ENROLLMENT_FETCHED,
    payload: enrollments
});